var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 800 600",
    xmlSpace: "preserve",
    viewBox: "0 0 200 155.79802",
    y: "0px",
    x: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-166.32586,-222.11295)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a41e11",
    d: "m334.77,339.54c-9.078,4.732-56.106,24.068-66.118,29.287-10.012,5.221-15.574,5.17-23.483,1.389s-57.955-23.996-66.97-28.305c-4.506-2.154-6.875-3.971-6.875-5.688v-17.195s65.153-14.184,75.672-17.957c10.518-3.774,14.167-3.91,23.118-0.631,8.952,3.279,62.474,12.936,71.321,16.176,0,0-0.004,15.357-0.004,16.951,0.001,1.7-2.04,3.565-6.661,5.973z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d82c20",
    d: "m334.77,322.34c-9.078,4.73-56.106,24.068-66.118,29.287-10.012,5.221-15.574,5.17-23.483,1.389-7.91-3.779-57.955-23.998-66.97-28.305-9.015-4.309-9.204-7.275-0.348-10.742,8.855-3.469,58.626-22.996,69.146-26.77,10.518-3.772,14.167-3.91,23.118-0.63,8.952,3.279,55.699,21.886,64.545,25.126,8.848,3.243,9.188,5.913,0.11,10.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a41e11",
    d: "m334.77,311.5c-9.078,4.732-56.106,24.068-66.118,29.289-10.012,5.219-15.574,5.168-23.483,1.387-7.91-3.779-57.955-23.996-66.97-28.305-4.506-2.154-6.875-3.969-6.875-5.686v-17.197s65.153-14.183,75.672-17.957c10.518-3.773,14.167-3.91,23.118-0.631,8.952,3.279,62.474,12.934,71.321,16.175,0,0-0.004,15.357-0.004,16.953,0.001,1.699-2.04,3.564-6.661,5.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d82c20",
    d: "m334.77,294.3c-9.078,4.732-56.106,24.068-66.118,29.289-10.012,5.219-15.574,5.168-23.483,1.387-7.91-3.779-57.955-23.997-66.97-28.305s-9.204-7.274-0.348-10.743c8.855-3.467,58.626-22.995,69.146-26.768,10.518-3.773,14.167-3.91,23.118-0.631,8.952,3.279,55.699,21.885,64.545,25.126,8.848,3.242,9.188,5.913,0.11,10.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a41e11",
    d: "m334.77,282.42c-9.078,4.732-56.106,24.069-66.118,29.29-10.012,5.219-15.574,5.168-23.483,1.387-7.91-3.779-57.955-23.997-66.97-28.305-4.506-2.154-6.875-3.97-6.875-5.686v-17.197s65.153-14.183,75.672-17.956c10.518-3.774,14.167-3.91,23.118-0.631,8.952,3.279,62.474,12.934,71.321,16.175,0,0-0.004,15.357-0.004,16.952,0.001,1.698-2.04,3.563-6.661,5.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d82c20",
    d: "m334.77,265.22c-9.078,4.732-56.106,24.069-66.118,29.289-10.012,5.219-15.574,5.168-23.483,1.388s-57.955-23.997-66.97-28.305-9.204-7.275-0.348-10.743c8.855-3.468,58.626-22.994,69.146-26.768,10.518-3.774,14.167-3.91,23.118-0.63,8.952,3.279,55.699,21.885,64.545,25.126,8.848,3.24,9.188,5.912,0.11,10.643z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.67,248.66,263.93,250.19,260.63,258.13,255.3,249.27,238.28,247.74,250.98,243.16,247.17,236.13,259.06,240.78,270.27,237.11,267.24,244.38",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.75,287.18,232.24,275.77,271.66,269.72",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    d: "m 242.681,261.241 c 0,4.51051 -9.43291,8.167 -21.069,8.167 -11.63609,0 -21.069,-3.65649 -21.069,-8.167 0,-4.51051 9.43291,-8.167 21.069,-8.167 11.63609,0 21.069,3.65649 21.069,8.167 z",
    cx: 221.61,
    rx: 21.069,
    ry: 8.167,
    cy: 261.24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.09,250.83,319.42,260.05,296.11,269.26",
    fill: "#7a0c00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.28,261.04,296.09,250.83,296.11,269.26,293.58,270.25",
    fill: "#ad2115"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/redis.4cb87f24.svg";
export { ForwardRef as ReactComponent };